import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useBlockNavigation } from '../../../../common/hooks/useBlockNavigation'
import { UseI18n } from '../../../../common/hooks/useI18n'
import { Element } from '../../../../common/html/element'
import { Radio } from '../../../../common/html/radio'
import { PopupAction } from '../../../../common/popup/PopupAction'
import { selectCompanyInfo } from '../../header/companyInfo/store/slice'
import { jsonToString } from './helper'
import classes from './index.module.scss'
import {
  selectCompanyTypeTemplate,
  selectDefaultTemplate,
  selectIsDisableBlockNavigate,
  selectIsFiinGateTemplate,
  selectName,
  selectPanelById,
  selectPanelId,
} from './store/slice'

const CheckOutScreen = ({ saveTemplate, ignorePath }) => {
  const defaultTemplate = useSelector(selectDefaultTemplate)
  const panelId = useSelector(selectPanelId)
  const panelById = useSelector(selectPanelById)
  const name = useSelector(selectName)
  const isFiinGateTemplate = useSelector(selectIsFiinGateTemplate)
  const companyInfo = useSelector(selectCompanyInfo)
  const companyTypeTemplate = useSelector(selectCompanyTypeTemplate)
  const isDisableBlockNavigate = useSelector(selectIsDisableBlockNavigate)

  const companyType = companyTypeTemplate || companyInfo.companyType

  const isNotHasChange =
    name.trim() === defaultTemplate.templateName &&
    jsonToString(panelId.map((id) => ({ ...panelById[id], id: undefined }))) ===
      jsonToString(
        defaultTemplate.panelId.map((id) => ({
          ...defaultTemplate.panelById[id],
          id: undefined,
        })),
      )

  const { showPrompt, confirmNavigation, cancelNavigation } =
    useBlockNavigation({
      isBlock: !isNotHasChange && !isDisableBlockNavigate,
      ignorePath,
    })

  const placeHolder = UseI18n('preferenceSetting.PLH_INPUT')

  const [isShowPopupSaveAs, setIsShowPopupSaveAs] = useState(false)
  const [isSaveAs, setIsSaveAs] = useState(false)
  const [valueInput, setValueInput] = useState('')

  useEffect(() => {
    if (isFiinGateTemplate) {
      setIsSaveAs(true)
    }
  }, [isFiinGateTemplate])

  const showPopupSaveAs = () => {
    setIsShowPopupSaveAs(true)
  }

  const closePopupSaveAs = () => {
    cancelNavigation()
    setIsShowPopupSaveAs(false)
  }

  const changeInput = (e) => setValueInput(e.target.value)

  const submit = async () => {
    setIsShowPopupSaveAs(false)

    const panels = panelId.map((id) => panelById[id])
    const data = {
      templateName: valueInput.trim(),
      panels,
      isFiinGateTemplate,
      companyType,
    }

    if (!isSaveAs) {
      data.templateId = defaultTemplate.templateId
      data.templateName = name.trim()
    }

    const result = await saveTemplate(data)

    if (result) {
      confirmNavigation()
    }
  }

  const isDisableSubmit = isSaveAs ? !valueInput?.trim() : !name?.trim()
  const isDisableSaveChange = isFiinGateTemplate

  return (
    <>
      <PopupAction
        isShow={showPrompt}
        title="preferenceSetting.SAVE_CHANGE"
        handleClose={cancelNavigation}
        btnCancel={{
          label: 'common.NO',
          event: confirmNavigation,
          isI18n: true,
        }}
        btnSubmit={{
          label: 'common.YES',
          event: showPopupSaveAs,
          isI18n: true,
        }}
        disableKeyDown
      >
        <Translate value="preferenceSetting.SAVE_CHANGE_NOTE" />
      </PopupAction>
      <PopupAction
        isShow={isShowPopupSaveAs}
        title="preferenceSetting.SAVE_CHANGE"
        handleClose={closePopupSaveAs}
        btnCancel={{
          label: 'preferenceSetting.CANCEL',
          event: closePopupSaveAs,
          isI18n: true,
        }}
        btnSubmit={{
          label: 'preferenceSetting.SAVE',
          event: submit,
          isI18n: true,
          disabled: isDisableSubmit,
        }}
      >
        <Element>
          <Element>
            <Radio
              title={
                <>
                  <Translate value="preferenceSetting.SAVE_CHANGE_TO" /> "
                  {defaultTemplate.templateName}"
                </>
              }
              isI18n={false}
              value={false}
              activeValue={isSaveAs}
              onChange={setIsSaveAs}
              titleStyle={{
                fontWeight: 600,
                color: isDisableSaveChange ? '#9C9C9C' : '#3A414B',
              }}
              disabled={isDisableSaveChange}
            />
          </Element>
          <Element style={{ marginTop: 14 }}>
            <Radio
              title="preferenceSetting.SAVE_AS"
              value={true}
              activeValue={isSaveAs}
              onChange={setIsSaveAs}
              titleStyle={{ fontWeight: 600, color: '#3A414B' }}
            />
            <Element className="mt1">
              <Element
                elementName="input"
                style={{ border: '1px solid #E0E0E0' }}
                className={classes.inputSaveAs}
                placeholder={placeHolder}
                value={valueInput}
                onChange={changeInput}
              />
            </Element>
          </Element>
        </Element>
      </PopupAction>
    </>
  )
}

CheckOutScreen.propTypes = {
  defaultTemplateProp: PropTypes.object,
  saveTemplate: PropTypes.func,
}

CheckOutScreen.defaultProps = {
  saveTemplate: () => {},
}

export default CheckOutScreen
